import { render, staticRenderFns } from "./EditContentMove.vue?vue&type=template&id=c88ec304&"
import script from "./EditContentMove.vue?vue&type=script&lang=js&"
export * from "./EditContentMove.vue?vue&type=script&lang=js&"
import style0 from "./EditContentMove.vue?vue&type=style&index=0&id=c88ec304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports